import PropTypes from 'prop-types';
import { Icon } from '@iconify/react';
import { useRef, useState } from 'react';
import editFill from '@iconify/icons-eva/edit-fill';
import awardOutline from '@iconify/icons-eva/award-outline';
import { LinkasRouterLink, useNavigate } from 'react-router-dom';
import trash2Outline from '@iconify/icons-eva/trash-2-outline';
import moreVerticalFill from '@iconify/icons-eva/more-vertical-fill';
import checkmarkCircleOutline from '@iconify/icons-eva/checkmark-circle-outline';
// material
import { Menu, MenuItem, IconButton, ListItemIcon, ListItemText } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import isEligible from '../../../utils/roleEligibleGetter';

// ----------------------------------------------------------------------

ServicesMoreMenu.propTypes = {
  rowData: PropTypes.object.isRequired,
  onDelete: PropTypes.func.isRequired
};

export default function ServicesMoreMenu({ onDelete: deleteLayanan, rowData }) {
  const ref = useRef(null);
  const [isOpen, setIsOpen] = useState(false);
  const theme = useTheme();
  const navigate = useNavigate();

  return (
    <>
      <IconButton ref={ref} onClick={() => setIsOpen(true)}>
        <Icon icon={moreVerticalFill} width={20} height={20} />
      </IconButton>

      <Menu
        open={isOpen}
        anchorEl={ref.current}
        onClose={() => setIsOpen(false)}
        PaperProps={{
          sx: { width: 250, maxWidth: '100%' }
        }}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <MenuItem
          onClick={() => navigate(`/dashboard/services/${rowData.id}`)}
          sx={{ color: 'text.secondary' }}
        >
          <ListItemIcon>
            <Icon icon={editFill} width={24} height={24} />
          </ListItemIcon>
          <ListItemText primary="Lihat Data" primaryTypographyProps={{ variant: 'body2' }} />
        </MenuItem>

        {['hosting', 'subdomain'].includes(rowData.type) && (
          <MenuItem
            onClick={() =>
              navigate(`/dashboard/services/${rowData?.meta?.data_permohonan?.id_rekomendasi}`)
            }
            sx={{ color: 'text.secondary' }}
          >
            <ListItemIcon>
              <Icon icon={awardOutline} width={24} height={24} />
            </ListItemIcon>
            <ListItemText
              primary="Lihat Rekomendasi"
              primaryTypographyProps={{ variant: 'body2' }}
            />
          </MenuItem>
        )}

        {['hosting', 'subdomain'].includes(rowData.type) && (
          <>
            {isEligible('pemenuhan_rekomendasi') && (
              <MenuItem
                onClick={() =>
                  navigate(
                    `/dashboard/services/check/${rowData?.meta?.data_permohonan?.id_rekomendasi}`
                  )
                }
                sx={{ color: 'text.secondary' }}
              >
                <ListItemIcon>
                  <Icon icon={checkmarkCircleOutline} width={24} height={24} />
                </ListItemIcon>
                <ListItemText
                  primary="Pemenuhan Rekomendasi"
                  primaryTypographyProps={{ variant: 'body2' }}
                />
              </MenuItem>
            )}
          </>
        )}

        {['draft'].includes(rowData.status) && (
          <>
            {isEligible('hapus_layanan') && (
              <MenuItem
                onClick={() => {
                  deleteLayanan(rowData);
                  setIsOpen(false);
                }}
                sx={{ color: 'text.secondary' }}
              >
                <ListItemIcon>
                  <Icon
                    icon={trash2Outline}
                    width={24}
                    height={24}
                    color={theme.palette.error.main}
                  />
                </ListItemIcon>

                <ListItemText primary="Hapus" primaryTypographyProps={{ variant: 'body2' }} />
              </MenuItem>
            )}
          </>
        )}
      </Menu>
    </>
  );
}
